export default {
	"models.available": "可用",
	"models.expired": "已失效",
	"models.unavailable": "不可用",
	"models.wrongType": "错误的type：",
	"models.error": "出错了",
	"models.ReceivedSuccessfully": "领取成功",
	"models.loading": "正在加载..."
}